// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b45848a4","287":"f56115e7","322":"6d7bc9e4","364":"a40e60f3","474":"0db34c2d","693":"2e5d2cc9","715":"65960975","819":"b50879eb","953":"87e1a5d7"}[chunkId] + ".chunk.js";
};